import { render, staticRenderFns } from "./login-msm.vue?vue&type=template&id=4b87aa46&scoped=true"
import script from "./login-msm.vue?vue&type=script&lang=js"
export * from "./login-msm.vue?vue&type=script&lang=js"
import style0 from "./login-msm.vue?vue&type=style&index=0&id=4b87aa46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87aa46",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/account/model/login-msm.vue
// module id = null
// module chunks = 